export default data => {
  return {
    '@type': 'TelevisionChannel',
    name: data?.title,
    description: data?.description,
    url: data?.canonicalUrl,
    image: data?.image,
  };
};
